
import { useSelector, useDispatch } from "react-redux";
import Icon from "@identitybuilding/idb-react-iconlib";
import React from "react";
import "../assets/css/FollowingConflict.css"
import { Button } from "@identitybuilding/idb-react-ui-elements";
import { toggleOpenFollowingConflict } from '../actions/AccountAction.js';
import axios from 'axios'
import { getEnvEndpoints } from "../utils/functions.js";


const FollowingConflict = () => {
    const { translate, lang } = useSelector(state => state.general);
    const { openFollowingConflict } = useSelector(state => state.account);
    const dispatch = useDispatch();
    const env = getEnvEndpoints();

    const SwitchFollowerHandler = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("StadGemeenteToken")}`,
        };
        axios.post(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/catalogus/switch_following_establishment/?lang=${lang}`, {
            headers: headers,
            token: localStorage.getItem("StadGemeenteToken"),
            data: openFollowingConflict
        }).then(() => {
            window.location.reload()
        })
    }

    return (
        <div className="follwongConflict">
            <div className="container">
                <Icon name="Close" onClick={() => dispatch(toggleOpenFollowingConflict(false))} />
                <h3>{translate('you_cant_follow_2_stores_of_the_same_category')}</h3>
                <span>{translate('you_follow')}: <b>{openFollowingConflict.name}</b></span>
                <figure><img src={openFollowingConflict.main_logo} alt="logo of already following establishment" /></figure>


                {(() => {
                    const estName = openFollowingConflict.current_est[`name`] || openFollowingConflict.current_est[`name_${lang}`] || openFollowingConflict.current_est.name_nl || openFollowingConflict.current_est.name_fr || openFollowingConflict.current_est.name_de || openFollowingConflict.current_est.name_en;
                    const textMap = {
                        nl: { before: "Wil je van", after: "jouw favoriete winkel maken?" },
                        fr: { before: "Voulez-vous faire de", after: "votre magasin préféré ?" },
                        en: { before: "Do you want to make", after: "your favorite store?" },
                        de: { before: "Möchten Sie", after: "zu Ihrem Lieblingsgeschäft machen?" },
                    };
                    const t = textMap[lang] || textMap.nl;
                    return <span>{t.before} <b>{estName}</b> {t.after}</span>;
                })()}

                <div className="buttons">
                    <Button
                        borderColor='success'
                        text={`${translate('yes_message')}`}
                        txtColor='success'
                        type='sub'
                        size='S'
                        onClick={() => SwitchFollowerHandler()}
                    />
                    <Button
                        borderColor='error'
                        text={`${translate('no_message')}`}
                        txtColor='error'
                        type='sub'
                        size='S'
                        onClick={() => dispatch(toggleOpenFollowingConflict(false))}
                    />
                </div>
            </div>
        </div>
    );
}

export default FollowingConflict;
